import React, { Suspense } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';

// Lazy loading: code is only downloaded when user visits the corresponding route
// Landing page is usually light, but we lazy load for consistency
const LandingPage = React.lazy(() => import('./pages/Landing'));

// Auth callback - lazy loaded since it's only used during authentication
const AuthCallback = React.lazy(() => import('./pages/Auth/Callback'));

// Web App - lazy loaded since it contains heavy UI libraries
const AppLayout = React.lazy(() => import('./layouts/AppLayout'));
const LoginPage = React.lazy(() => import('./pages/Auth/LoginPage'));
const RegisterPage = React.lazy(() => import('./pages/Auth/RegisterPage'));
const SquarePage = React.lazy(() => import('./pages/Square'));
const SubscriptionsPage = React.lazy(() => import('./pages/Subscriptions'));
const CloudClippingsPage = React.lazy(() => import('./pages/CloudClippings'));

// Simple loading spinner component
const PageLoader = () => (
  <div className="h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
  </div>
);

export const router = createBrowserRouter([
  // Landing page for download/marketing
  {
    path: '/landing',
    element: (
      <Suspense fallback={null}>
        <LandingPage />
      </Suspense>
    ),
  },
  // Root redirect 根目录重定向
  {
    path: '/',
    element: <Navigate to="/landing" replace />,
  },
  // Auth routes
  {
    path: '/auth/login',
    element: (
      <Suspense fallback={<PageLoader />}>
        <LoginPage />
      </Suspense>
    ),
  },
  {
    path: '/auth/register',
    element: (
      <Suspense fallback={<PageLoader />}>
        <RegisterPage />
      </Suspense>
    ),
  },
  {
    path: '/auth-callback',
    element: (
      <Suspense fallback={<PageLoader />}>
        <AuthCallback />
      </Suspense>
    ),
  },
  // Main app routes with sidebar layout
  {
    path: '/',
    element: (
      <Suspense fallback={<PageLoader />}>
        <AppLayout />
      </Suspense>
    ),
    children: [
      {
        path: 'square',
        element: (
          <Suspense fallback={<PageLoader />}>
            <SquarePage />
          </Suspense>
        ),
      },
      {
        path: 'square/:id',
        element: (
          <Suspense fallback={<PageLoader />}>
            <SquarePage />
          </Suspense>
        ),
      },
      {
        path: 'subscriptions',
        element: (
          <Suspense fallback={<PageLoader />}>
            <SubscriptionsPage />
          </Suspense>
        ),
      },
      {
        path: 'subscriptions/:id',
        element: (
          <Suspense fallback={<PageLoader />}>
            <SubscriptionsPage />
          </Suspense>
        ),
      },
      {
        path: 'cloud-clippings',
        element: (
          <Suspense fallback={<PageLoader />}>
            <CloudClippingsPage />
          </Suspense>
        ),
      },
      {
        path: 'cloud-clippings/:view',
        element: (
          <Suspense fallback={<PageLoader />}>
            <CloudClippingsPage />
          </Suspense>
        ),
      },
    ],
  },
  // 404 redirects to square
  {
    path: '*',
    element: <Navigate to="/square" replace />,
  },
]);
